
<template>
  <div id="dialog-business-contact">
    <div class="dialog">
      <span class="cls" @click="oth_showBusinessContact(false)"></span>
      <div class="paper">
        <div class="header">
          <h1>청구연락처</h1>
          <span @click="oth_showBusinessContact(false)"> <i class="ph-bold ph-x"></i> </span>
        </div>
        <div class="tab-buttons">
          <button @click="selectViewType('fire')" :class="{ active: viewListType === 'fire' }">손해보험</button>
          <button @click="selectViewType('life')" :class="{ active: viewListType === 'life' }">생명보험</button>
        </div>
        <div class="content">
          <div> <span>회사</span> <span>대표번호</span> <span>보상접수처</span> </div>
          <ul>
            <template v-for="(company, i) in insuCompanys" :key="i">
              <li v-if="company.type === viewListType">
                <div class="company"><img :src="company?.short_img || 'https://blog.kakaocdn.net/dna/byIZZL/btsMyrQRWb9/AAAAAAAAAAAAAAAAAAAAAPG3vMG0hs5TXAjhk5fglaLksnKIs1thKShAX_CExXzA/img.png?credential=yqXZFxpELC7KVnFOS48ylbz2pIh7yKj8&expires=1756652399&allow_ip=&allow_referer=&signature=RiJCdOyh%2F3VqFVcfpzx0dlUXx%2F4%3D'" /> <span>{{ company?.name }}</span> </div>
                <span>Tel: {{ company?.phone }}</span>
                <div class="claim-info">
                  <template v-if="getInsuCompanyClaimInfo(company?.value)">
                    <span v-for="(item, i) in getInsuCompanyClaimInfo(company?.value)" :key="i">{{ item.value }} {{ item.label }} </span>
                  </template>
                  <template v-else>
                    <span class="b">청구접수처 정보가 없습니다.</span>
                  </template>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref } from 'vue';
import { useBackButton } from '@/utils/useBackBtn';

export default ({
  props: {
    oth_showBusinessContact: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const viewListType = ref('fire');
    const insuCompanys = inject('insuCompanys');
    const getInsuCompanyClaimInfo = inject('getInsuCompanyClaimInfo');

    
    useBackButton(() => {
      props.oth_showBusinessContact(false);
    });

    function selectViewType(type) {
      viewListType.value = type;
    }

    return {
      viewListType,
      selectViewType,
      insuCompanys,
      getInsuCompanyClaimInfo,
    };
  },
})
</script>


<style scoped>

#dialog-business-contact {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

#dialog-business-contact .dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(2px);
}

.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  position: relative;
  width: 100%;
  max-width:600px;
  height: 80%;
  background-color: var(--color-background);
  border:1px solid var(--color-text-primary);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  gap:16px;
}

.dialog > .paper > .header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.dialog > .paper > .header > h1 {
  font-size:20px;
}

.dialog > .paper > .header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}


.tab-buttons {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 2px solid var(--color-background-light);
}

.tab-buttons button {
  flex: 1;
  height: 52px;
  padding: 12px 0px;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
  color: var(--color-text-primary);
}

.tab-buttons button.active {
  color: var(--color-text-primary);
  border-bottom: 3px solid var(--color-text-primary);
  background-color: var(--color-background);
}

.content {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow:hidden;
}

.content > div {
  width:100%;
  height:36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-text-secondary);
}

.content > div > span {
  flex:2;
  display:flex;
  justify-content: center;
  align-items: center;
}

.content > div > span:first-child {
  flex:1;
}

.content > ul {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  flex-direction: column;
  gap:12px;
  list-style: none;
  padding:0;
  margin:0;
  overflow:scroll;
}

.content > ul::-webkit-scrollbar {
  display: none;
}

.content > ul > li {
  width:100%;
  min-height:100px;
  height:100px;
  display:flex;
  gap:4px;
  border-bottom:1px solid var(--color-text-secondary);
}

.content > ul > li:last-child {
  border-bottom: none;
}

.content > ul > li > .company {
  flex:1;
  height:100%;
  display:flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap:8px;
}

.content > ul > li > .company img {
  width: 50px;
  height: auto;
  border-radius: 8px;
}

.content > ul > li > .company > span {
  font-size: 14px;
  color: var(--color-text-primary);
  text-align: center;
}

.content > ul > li > .claim-info {
  flex:2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap:6px;
}

.content > ul > li > span {
  flex:2;
  display:flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.content > ul > li span.b {
  color: var(--color-text-primary);
  font-size: 14px;
  opacity: 0.7;
}
</style>